export const showNewPort = (status) => ['new'].includes(status);
export const showUpdatePort = (status) => ['port_valid'].includes(status);
export const showActivateSub = (status) => ['port_valid'].includes(status);
export const showPortModify = (status) => ['port_resp'].includes(status);
export const showPortCancel = (status) =>
  ['port_resp', 'port_valid', 'error'].includes(status);

export default (subId, status, callback) => {
  let links = [];
  if (showNewPort(status)) {
    links.push([`/subscriptions/${subId}/new-port`, 'New Port']);
  }
  if (showActivateSub(status)) {
    links.push([`/subscriptions/${subId}/activate`, 'Activate Subscription']);
  }
  if (showUpdatePort(status)) {
    links.push([`/subscriptions/${subId}/update-port`, 'Update Port']);
  }
  if (showPortModify(status)) {
    links.push([`/subscriptions/${subId}/port-modify`, 'Port Modify']);
  }
  if (showPortCancel(status)) {
    links.push([`/subscriptions/${subId}/port-cancel`, 'Port Cancel']);
  }

  return links.map((link, index) => callback(link[0], link[1], index));
};
